<template>
  <el-dialog v-bind="$attrs" append-to-body :title="title" :visible.sync="currentVisible" @close="handlerClose">
    <slot></slot>
  </el-dialog>
</template>

<script lang="jsx">
export default {
  name: 'baseDialog',
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:''
    },
  },
  data(){
    return {
      currentVisible: false,
    }
  },
  watch:{
    visible(val){
      this.currentVisible = val
    },
  },
  methods:{
    handlerClose(){
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.el-dialog {
  font-family: MicrosoftYaHei;
  &__header{
    text-align: center;
    span{
      font-size: 16px;
      font-weight: bold;
    }
  }
  &__body{
    padding: 30px;
  }
}
</style>